'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CallToActionLink = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _aphrodite = require('aphrodite');

var _base = require('../util/base64');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = _aphrodite.StyleSheet.create({
	successfulSignupWrapper: {
		padding: '35px',
		textAlign: 'center',
		width: '100%',
		maxWidth: '560px',
		borderRadius: '5px',
		backgroundColor: 'white',
		border: 'solid 1px #9da3a6',
		boxSizing: 'border-box'
	},
	mainTitle: {
		margin: 0
	},
	mainBlurb: {
		margin: '10px 0 15px'
	},
	a: {
		color: 'inherit',
		textDecoration: 'none'
	},
	linkWrappers: {
		width: '100%',
		padding: '25px',
		borderRadius: '5px',
		border: 'solid 1px #cbd2d6',
		textAlign: 'initial',
		position: 'relative',
		marginTop: '20px',

		':hover': {
			boxShadow: '0 0 4px #0070ba'
		}
	},
	linkDetails: {
		marginLeft: '72px'
	},
	linkTitle: {
		color: '#0070ba',
		margin: 0
	},
	linkContent: {
		margin: 0
	},
	icon: {
		position: 'absolute',
		width: '50px',
		height: '50px',
		top: '50%',
		marginTop: '-25px'
	},
	sendIcon: {
		backgroundImage: 'url(\'data:image/svg+xml;base64,' + _base.sendMoney + '\')',
		backgroundRepeat: 'no-repeat'
	},
	shopIcon: {
		backgroundImage: 'url(\'data:image/svg+xml;base64,' + _base.shop + '\')',
		backgroundRepeat: 'no-repeat'
	},
	profileIcon: {
		backgroundImage: 'url(\'data:image/svg+xml;base64,' + _base.profile + '\')',
		backgroundRepeat: 'no-repeat'
	}
});

// ———

var CallToActionLink = exports.CallToActionLink = function CallToActionLink(_ref) {
	var content = _ref.content;

	// helper to apply the correct base64 icon to the icon container
	var getIconStyle = function getIconStyle(type) {
		return styles[type + 'Icon'] || '';
	};

	return _react2.default.createElement(
		'a',
		{ className: (0, _aphrodite.css)(styles.a), href: content.linkDestination },
		_react2.default.createElement(
			'div',
			{ className: (0, _aphrodite.css)(styles.linkWrappers) },
			_react2.default.createElement('div', { className: (0, _aphrodite.css)(styles.icon, getIconStyle(content.type)) }),
			_react2.default.createElement(
				'div',
				{ className: (0, _aphrodite.css)(styles.linkDetails) },
				_react2.default.createElement(
					'h3',
					{ className: (0, _aphrodite.css)(styles.linkTitle) },
					content.title
				),
				_react2.default.createElement(
					'p',
					{ className: (0, _aphrodite.css)(styles.linkContent) },
					content.blurb
				)
			)
		)
	);
};

CallToActionLink.propTypes = {
	content: _propTypes2.default.shape({
		type: _propTypes2.default.oneOf(['send', 'shop', 'profile']).isRequired,
		title: _propTypes2.default.string.isRequired,
		blurb: _propTypes2.default.string.isRequired,
		linkDestination: _propTypes2.default.string.isRequired
	})
};

// ———

var SuccessfulSignup = function SuccessfulSignup(_ref2) {
	var mainTitle = _ref2.mainTitle,
	    mainBlurb = _ref2.mainBlurb,
	    linkContent = _ref2.linkContent;

	return _react2.default.createElement(
		'div',
		{ className: (0, _aphrodite.css)(styles.successfulSignupWrapper) },
		_react2.default.createElement(
			'h2',
			{ className: (0, _aphrodite.css)(styles.mainTitle) },
			mainTitle
		),
		_react2.default.createElement(
			'p',
			{ className: (0, _aphrodite.css)(styles.mainBlurb) },
			mainBlurb
		),
		linkContent.map(function (content, index) {
			return _react2.default.createElement(CallToActionLink, {
				key: index,
				content: content
			});
		})
	);
};

SuccessfulSignup.propTypes = {
	mainTitle: _propTypes2.default.string.isRequired,
	mainBlurb: _propTypes2.default.string.isRequired,
	linkContent: _propTypes2.default.arrayOf(_propTypes2.default.shape({
		type: _propTypes2.default.oneOf(['send', 'shop', 'profile']).isRequired,
		title: _propTypes2.default.string.isRequired,
		blurb: _propTypes2.default.string.isRequired,
		linkDestination: _propTypes2.default.string.isRequired
	})).isRequired
};

exports.default = SuccessfulSignup;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/SuccessfulSignup.js
// module id = 707
// module chunks = 5